// <s-back-link> wraps a plain link whose href is a sensible fallback page.
// When the visitor arrived from another page of this store, clicking it returns
// them to exactly where they were (same scroll position, filters and page) via
// history.back(). Otherwise the link's own href is followed.
class BackLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }

  #onClick = (event) => {
    if (!event.target.closest("a")) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    let referrer;
    try {
      referrer = new URL(document.referrer);
    } catch {
      return;
    }

    const sameStore = referrer.origin === window.location.origin;
    const samePage = referrer.pathname === window.location.pathname;
    const fromCheckout = referrer.pathname.includes("/checkouts");

    if (sameStore && !samePage && !fromCheckout && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  };
}

if (!customElements.get("s-back-link")) {
  customElements.define("s-back-link", BackLink);
}
